import React, { useState, useEffect, useCallback } from 'react';
import { 
  useParams 
} from 'react-router-dom';
import styled from 'styled-components';
import queryString from 'query-string';
import SourceConsent from '../components/common/SourceConsent';

const Account = () => {
  let { qstr } = useParams();
  const { c, s, redirect, consent } = queryString.parse(qstr);
  const { redirectUri } = queryString.parse(redirect);
  const [showConsent, setShowConsent] = useState(true);

  const openIframe = useCallback((url) => {
    window.finicityConnect.launch(url, {
      selector: '#connect-container',
      overlay: 'rgba(255,255,255, 0)',
      success: ({ reason }) => {
        console.log('', reason);
        if (reason === 'complete') {
          if (redirectUri) {
              window.location.replace(redirectUri);
          }
        }
      },
      cancel: ({ reason }) => {
        if (reason === 'exit') {
          if (redirectUri) {
              window.location.replace(redirectUri);
          }
        }
      },
      error: (error) => {
        console.error('', error);
      },
      loaded: () => {
        console.log('');
      },
      route: (event) => {
        console.log('', event);
      },
      user: ({ data }) => {
        console.log('', data);
        // const { action } = data;
        // if (action === "SubmitAccounts") {
        //   if (redirectUri) {
        //     window.location.replace(redirectUri);
        //   }
        // }
      }
    });
  }, [redirectUri])

  const handleRender = useCallback(() => {
    const url = decodeURIComponent(redirect)
    if (c === 'finicity') {
      setShowConsent(false)
      url.includes('/server/oauth') ? window.location.assign(url) : openIframe(url)
    } else {
      window.location.assign(url)
    }
  }, [c, openIframe, redirect])

  useEffect(() => {
    if (consent) {
      consent === 'n' ? handleRender() : setShowConsent(true)
    } else {
      setShowConsent(true)
    }
  }, [consent, handleRender])

  if (!c || !s) return <Container />

  const render = () => {
    if (showConsent) {
      return(
        <Content>
          <SourceConsent contributor={c} subscriber={s} />
          <Row style={{justifyContent: 'flex-end', padding: '0 2rem 1rem 1rem', width: '100%'}}>
            <Button onClick={handleRender}>
              I accept - Continue
            </Button>
          </Row>
        </Content>
      )
    }
  }

  return (
    <Container>
      <div>
        <div id='connect-container' />
      </div>
      {render()}
    </Container>
  );
}

export default Account;


const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: #3a3a3a;
  text-align: center;
`

const Content = styled.div`
  ${({ theme }) => theme.animations.fadeUp};
  min-width: 17rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
`

const Row = styled.div`
  display: flex;
  justify-content: center;
`

const Button = styled.button`
  color: #fff;
  background-color: ${({ theme }) => theme.colors.buttonPrimary};
  margin-left: 1rem;
  padding: .5rem .75rem;
  font-size: 1.1em;
`
